import { setupLayouts } from 'virtual:generated-layouts'
import generatedRoutes from 'virtual:generated-pages'
import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
// Generate routes
import NotFound from './layouts/404.vue'

// Local plugins
import ofetch from './plugins/ofetch'
import pages from './plugins/pages'
import pinia from './plugins/pinia'
import sentry from './plugins/sentry'
import web3modal from './plugins/web3modal'

import '@/styles/base.css'

const routes = setupLayouts(generatedRoutes)
const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...routes,
    { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFound },
  ],
})

// Vue setup
const app = createApp(App)

// Install all plugins under `packages/plugins/src` from monorepo root
Object.values(
  import.meta.glob('../../../packages/plugins/src/*.js', { eager: true }),
).forEach(i => app.use(i.default))

app.use(pinia)
app.use(pages, { router })
app.use(sentry, { router })
app.use(ofetch)
app.use(web3modal)
app.mount('#app')
